import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "../components/Logo";
import CreateSearch from "./CreateSearch";

export default function StartArtist() {
  return (
    <div className="min-h-screen">
      <header className="glass border-b border-zinc-800/70 sticky top-0 z-20">
        <div className="max-w-2xl mx-auto px-4 h-14 flex items-center justify-between">
          <Logo />
          <Link to="/login" className="text-sm text-zinc-300 hover:text-white">Connexion</Link>
        </div>
      </header>
      <div className="max-w-2xl mx-auto px-4 py-6">
        <CreateSearch />
      </div>
    </div>
  );
}
